import { loggingContexts } from "./data/logging-contexts.js";
import { log } from "./log.js";

const uncaughtErrorLog = log(loggingContexts.uncaughtError);

window.addEventListener("error", (errorEvent) => {
  uncaughtErrorLog.error(`event type error`);
  uncaughtErrorLog.error(errorEvent.error);
  uncaughtErrorLog.error(errorEvent.error.message);
  uncaughtErrorLog.error(errorEvent.error.stack);
});

window.addEventListener("unhandledrejection", function (promiseRejectionEvent) {
  uncaughtErrorLog.error("event type unhandledrejection");
  uncaughtErrorLog.error(promiseRejectionEvent.reason);
  uncaughtErrorLog.error(promiseRejectionEvent.reason.message);
  uncaughtErrorLog.error(promiseRejectionEvent.reason.stack);
});
